<app-entity-master
  [header]="'TRACKED_TIME.HEADER' | translate"
  [primaryAction]="primaryAction$ | async"
  [filters]="filters"
  [activeFilter]="activeFilter$ | async"
  [featureName]="featureName"
  [enableSearch]="true"
  [searchQuery]="searchQuery$ | async"
  [searchPlaceholder]="'TRACKED_TIME.SEARCH_PLACE_HOLDER' | translate"
  [defaultSearchParams]="defaultSearchParams$ | async"
  [trackingScreenName]="trackingScreenName"
  [trackingObject]="trackingObject"
  (onPrimaryAction)="trackTime()"
>
</app-entity-master>
